import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Link, Route, Redirect } from 'react-router-dom';
import { translate } from 'react-translate';
import AdSense from 'react-adsense';
import AdBlockDetect from 'react-ad-block-detect';

//IMPORT SEMANTIC COMPONENTS
import {
    Button,
    Container,
    Segment,
    Menu,
    Image,
    Dropdown,
    Header,
    List,
    Grid,
    Search,
    Advertisement,
    Icon,
    Divider,
    Table,
    Responsive,
    Item,
} from 'semantic-ui-react';

import './menuStyle.css'

//IMPORT REACT COMPONENTS

//IMPORT IMAGES
import Travaux from '../../assets/svg/Travaux.svg';
import Parametres from '../../assets/svg/Parametres.svg';
import Listes from '../../assets/svg/Listes.svg';
import Magasins from '../../assets/svg/Magasins.svg';
import Extensions from '../../assets/svg/Extensions.svg';
import Contact from '../../assets/svg/Contact.svg';
import icon_home_yoyo from '../../assets/svg/icon_home_yoyo.svg';

import TravauxNew from '../../assets/svg/TravauxNew.svg';
import Parquet from '../../assets/svg/Parquet.svg';
import ListesNew from '../../assets/svg/ListesNew.svg';
import Cloture from '../../assets/svg/Cloture.svg';
import Murs from '../../assets/svg/Murs.svg';
import BigHome from '../../assets/svg/BigHome.svg';
import News from '../../assets/svg/News.svg';
import zoum from '../../assets/icons/zoum.png';
import bg2 from '../../assets/icons/bg2.png';
import bg from '../../assets/icons/bg.png';

import icon_home_white from '../../assets/svg/icon_home_white.svg';
import Travaux_white from '../../assets/svg/Travaux_white.svg';
import Listes_white from '../../assets/svg/Listes_white.svg';
import Extensions_white from '../../assets/svg/Extensions_white.svg';
import Parametres_white from '../../assets/svg/Parametres_white.svg';
import Contact_white from '../../assets/svg/Contact_white.svg';
import searchIconWhite from '../../assets/svg/searchIconWhite.svg';
import searchIconBlue from '../../assets/svg/searchIconBlue.svg';


import './protectedComponent.css'
import './protectedGeneralStyles.css'
import MenuComponent from '../Public/MenuComponent';
import FooterComponent from '../Public/FooterComponent';
import ProtectedRouter from './ProtectedRouter'


import { connect } from 'react-redux';

import {
    addWorkId,
} from '../../redux/actions/ConfigFileAction'

import API from '../../services/api';

const mapStateToProps = state => ({
    app: state.app,
    configfile: state.configfile
})

const mapActionToProps = {
    addWorkId: addWorkId
}


class ConnectedProtectedComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            hasNoAdExtension : false
        };
        // this.toggleBlocking = this.toggleBlocking.bind(this);
        this.addWorkId = this.addWorkId.bind(this)
    }

 
    componentWillMount() {
        var self = this;
        var subData = {
            id: this.props.app.id
        }
        API.getSub(this.props.app.token, subData).then((res) => {
            if(res.data && res.data.code == 200) {
                Object.keys(res.data).forEach(function(key) {
                    if(key === 'code' || key === 'msg') {
                        return;
                    }
                    if(res.data[key].pkuidsub === 1) {
                        self.setState({
                            hasNoAdExtension : true
                        })
                    }
                });
            }
        })

    }

    addWorkId(e) {
        e.preventDefault();
        this.props.addWorkId(null);

        if (!(this.props.match.path === '/works' && this.props.match.isExact)) {
            this.setState({
                redirect: true
            })
        }
    }


    render() {
        const { t } = this.props
        // var MenuItemStyle = {
        //     color: '#0964c1',
        //     height: '70px',
        //     fontSize: '1.4em',
        //     lineHeight: '1.4em',
        // }
        //
        // var MenuItemSelectedStyle = {
        //     backgroundColor: '#0964c1',
        //     color: '#ffffff',
        //     height: '70px',
        //     fontSize: '1.4em',
        //     lineHeight: '1.4em',
        // }

        var sectionStyle = {
            backgroundImage: "url(" + zoum + ")",
            backgroundColor: '#e6eaef',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100%',
            paddingTop: '75px',
        }

        if (this.props.match.path === window.location) {

        }

        return (
            <div>
                {
                    this.state.redirect ? (
                        <Redirect
                            to={{
                                pathname: "/works",
                            }}
                        />
                    ) : (
                            <div></div>
                        )
                }
                <MenuComponent />
                <div style={sectionStyle}>

                    <Grid padded stackable>
                        <Grid.Row centered>
                            <Grid.Column width={3}>
                            {
                                this.state.hasNoAdExtension ? (
                                    <div> </div>
                                ) : (
                                    <Segment compact>
                                        <Container fluid>
                                            <Advertisement centered unit='leaderboard'>
                                                <AdSense.Google
                                                className='adsbygoogle'
                                                client='ca-pub-4591861188995436'
                                                format='auto'
                                                slot='4640466102'
                                                style={{ display: 'block' }}
                                                />
                                                <AdBlockDetect>
                                                    <p> Please disable AdBlock !</p>
                                                </AdBlockDetect>
                                            </Advertisement>
                                        </Container>
                                    </Segment>
                                )
                            }
                            
                        </Grid.Column>
                        </Grid.Row>
                        <Grid.Row doubling="true" stackable="true" columns={3} centered>
                            <Grid.Column width={4}>
                            <Responsive minWidth={1025}>
                              <Menu className='menuBig' id="BigMenu" fluid vertical size='large' >
                                    <Link to='/homepage'>
                                        {
                                            this.props.match.path === '/homepage' ? (
                                                <Menu.Item id="menuItemSelectedStyle">
                                                    {t("MenuItem1_title")}
                                                    <Image src={icon_home_white} floated='left' size='mini'  id="imgMenuTitle" />
                                                </Menu.Item>
                                            ) : (
                                                    <Menu.Item id="menuItemStyle">
                                                        {t("MenuItem1_title")}
                                                        <Image src={icon_home_yoyo} floated='left' size='mini' id="imgMenuTitle" />
                                                    </Menu.Item>
                                                )
                                        }
                                    </Link>
                                    <Link to='/works' onClick={this.addWorkId}>
                                        {
                                            (this.props.match.path === '/works' || this.props.match.path === '/works/:id'
                                            || this.props.match.path === '/works/:beta' || this.props.match.path === '/works/:beta/:id') ? (
                                                <Menu.Item id="menuItemSelectedStyle"  >
                                                    {t("MenuItem2_title")}
                                                    <Image src={Travaux_white} floated='left' size='mini' id="imgMenuTitle" />
                                                </Menu.Item>
                                            ) : (
                                                    <Menu.Item id="menuItemStyle">
                                                        {t("MenuItem2_title")}
                                                        <Image src={Travaux} floated='left' size='mini' id="imgMenuTitle" />
                                                    </Menu.Item>
                                                )
                                        }
                                    </Link>
                                    <Link to='/lists'>
                                        {
                                            (this.props.match.path === '/lists' || this.props.match.path === '/listdetail/:id') ? (
                                                <Menu.Item id="menuItemSelectedStyle">
                                                    {t("MenuItem3_title")}
                                                    <Image src={Listes_white} floated='left' size='mini' id="imgMenuTitle" />
                                                </Menu.Item>
                                            ) : (
                                                    <Menu.Item id="menuItemStyle">
                                                        {t("MenuItem3_title")}
                                                        <Image src={Listes} floated='left' size='mini' id="imgMenuTitle" />
                                                    </Menu.Item>
                                                )
                                        }
                                    </Link>
                                    <Link to='/subs'>
                                        {
                                            this.props.match.path === '/subs' ? (
                                                <Menu.Item id="menuItemSelectedStyle">
                                                    {t("MenuItem4_title")}
                                                    <Image src={Extensions_white} floated='left' size='mini' id="imgMenuTitle" />
                                                </Menu.Item>
                                            ) : (
                                                    <Menu.Item id="menuItemStyle">
                                                        {t("MenuItem4_title")}
                                                        <Image src={Extensions} floated='left' size='mini' id="imgMenuTitle" />
                                                    </Menu.Item>
                                                )
                                        }
                                    </Link>
                                    <Link to='/recherche'>
                                        {
                                            this.props.match.path === '/recherche' ? (
                                                <Menu.Item id="menuItemSelectedStyle">
                                                    {t("MenuItem7_title")}
                                                    <Image src={searchIconWhite} floated='left' size='mini' id="imgMenuTitle" />
                                                </Menu.Item>
                                            ) : (
                                                    <Menu.Item id="menuItemStyle">
                                                        {t("MenuItem7_title")}
                                                        <Image src={searchIconBlue} floated='left' size='mini' id="imgMenuTitle" />
                                                    </Menu.Item>
                                                )
                                        }
                                    </Link>
                                    <Link to='/settings'>
                                        {
                                            this.props.match.path === '/settings' ? (
                                                <Menu.Item id="menuItemSelectedStyle">
                                                    {t("MenuItem5_title")}
                                                    <Image src={Parametres_white} floated='left' size='mini' id="imgMenuTitle" />
                                                </Menu.Item>
                                            ) : (
                                                    <Menu.Item id="menuItemStyle">
                                                        {t("MenuItem5_title")}
                                                        <Image src={Parametres} floated='left' size='mini' id="imgMenuTitle" />
                                                    </Menu.Item>
                                                )
                                        }
                                    </Link>
                                    <Link to='/contact'>
                                        {
                                            this.props.match.path === '/contact' ? (
                                                <Menu.Item id="menuItemSelectedStyle">
                                                    {t("MenuItem6_title")}
                                                    <Image src={Contact_white} floated='left' size='mini' id="imgMenuTitle" />
                                                </Menu.Item>
                                            ) : (
                                                    <Menu.Item id="menuItemStyle">
                                                        {t("MenuItem6_title")}
                                                        <Image src={Contact} floated='left' size='mini' id="imgMenuTitle" />
                                                    </Menu.Item>
                                                )
                                        }
                                    </Link>
                                    {/* <Link to='/works'><Menu.Item id='menu-item' className='menu-item' class='menu-item' style={MenuItemStyle}>{t("MenuItem2_title")}<Image src={Travaux} floated='left' size='mini' /></Menu.Item></Link>
                                    <Link to='/lists'><Menu.Item className='menu-item' style={MenuItemStyle}>{t("MenuItem3_title")}<Image src={Listes} floated='left' size='mini' /></Menu.Item></Link>
                                    <Link to='/subs'><Menu.Item className='menu-item' style={MenuItemStyle}>{t("MenuItem4_title")}<Image src={Extensions} floated='left' size='mini' /></Menu.Item></Link> */}
                                    {/* <Menu.Item style={MenuItemStyle}><Link to='/Magasins'>Magasins</Link><Image src={Magasins} floated='left' size='mini' /></Menu.Item> */}
                                    {/* <Link to='/settings'><Menu.Item className='menu-item' style={MenuItemStyle}>{t("MenuItem5_title")}<Image src={Parametres} floated='left' size='mini' /></Menu.Item></Link>
                                    <Link to='/contact'><Menu.Item className='menu-item' style={MenuItemStyle}>{t("MenuItem6_title")}<Image src={Contact} floated='left' size='mini' /></Menu.Item></Link> */}
                                    {/* <Menu.Item style={MenuItemStyle}><Link to='/protected'>Protected area</Link><Image src={Contact} floated='left' size='mini' /></Menu.Item> */}
                                    {/* <Menu.Item><Link to='/dashboard'>Dashboard</Link></Menu.Item> */}
                                </Menu>
                              </Responsive>
                                {
                                    this.state.hasNoAdExtension ? (
                                        <div> </div>
                                    )  : (
                                        <Segment compact style={{display:'block'}}>
                                            <Container fluid>
                                                <Advertisement centered unit='medium rectangle'>
                                                    <AdSense.Google
                                                        className='adsbygoogle'
                                                        client='ca-pub-4591861188995436'
                                                        format='auto'
                                                        slot='4640466102'
                                                        style={{ display: 'block' }}
                                                    />
                                                    <AdBlockDetect>
                                                        <p> Please disable AdBlock !</p>
                                                    </AdBlockDetect>
                                                </Advertisement>
                                            </Container>
                                        </Segment>
                                    )
                                }
                                
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={16} computer={12} id="rightColumnProtected" style={{maxWidth: '1100px'}}>
                                <Segment>
                                    <ProtectedRouter />
                                    {/* /*A tester pour passer les props dans tous les Content COmponents{...props}*/}
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </div>
                <FooterComponent />
            </div>
        );
    }
}

const ProtectedComponent = connect(mapStateToProps, mapActionToProps)(ConnectedProtectedComponent);
export default translate("ProtectedComponent")(ProtectedComponent);



// WEBPACK FOOTER //
// ./src/components/Protected/ProtectedComponent.js